/************************************************************
MechanicalSearch.tsx - To Search and Select required Gloves
*************************************************************/
import React, { useState, useCallback, useEffect } from 'react';
import './GloveSelector.scss';
import Breadcrumb from '../../../common/Breadcrumb/Breadcrumb';
import { BsSearch } from 'react-icons/bs';
import { ImgNoGloves } from './glovesSelection';
import FilterFacets from "../filterFacets/filterFacets";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { kclRootState } from "../../../../store/gloveSelectorStore";
import { addAnalytics } from "../../../common/functions/utils";
import { gloveProductList } from "../../../../types/allTypes";
import { utilAnalytics } from '../../../common/analytics/analyticsUtil';

let searchflag = 0;
const GlovesSelector = () => {
  const [productList, setProductList] = useState<gloveProductList>([]);
  const filterFacets = useSelector((state: kclRootState) => state?.glovesSelector?.setFilterFacets || {});
  const [displayItems, setDisplayItems] = useState<number>(20);
  const [searchTermText, setSearchTermText] = useState<string>("");
  const [sucessMsg, setSucessMsg] = useState<boolean>(true);
  const [setflag, setFlag] = useState<boolean>(false);
  const { t } = useTranslation();
  const gloveResults = useSelector((state: kclRootState) => state?.glovesSelector?.calculator?.gloveResults || []);
  const { FACET_FLOWS } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
  const loadMore = () => {
    setDisplayItems(displayItems + 10);
  };


  useEffect(() => {

    setProductList(gloveResults?.result?.results);
    const productRecordsCount = gloveResults?.result?.results?.length;
    setSucessMsg(gloveResults?.isSuccess);

    if (filterFacets.length !== undefined && filterFacets.length > 0) {
      sendSelectedFilterGloveDataToAnalytics(filterFacets, productRecordsCount);
    }

  }, [gloveResults]);



  const sendSelectedFilterGloveDataToAnalytics = (filterData, totalRecords) => {

    const filterAnalyticData = new Array();
    filterData?.forEach((arrayItem) => {
      const entries = Object.entries(arrayItem);
      for (const [key, value] of entries) {
        let newValue: string[] = value as Array<string>;
        const newKey: string = key;
        const filterDataValue = newValue.toString().replaceAll(",", "|");
        filterAnalyticData.push({ [`${newKey}`]: filterDataValue });
      }
    });
    filterAnalyticData.push({ "totalRecords": totalRecords || 0 });
    const customData = {
      "event": "glovesFiltersSelected",
      "filterData": filterAnalyticData
    };
    addAnalytics(customData);
  };

  const handleSearch = (e) => {
    setSearchTermText(e.target.value);

  };

  const showProductPDF = (productName, productUrl) => {
    const styleNumberSelected = {
      "event": "productTilesClicked",
      "productTilesClicked": productName
    };
    addAnalytics(styleNumberSelected);
    utilAnalytics(
      true,
      {
        event: "productTilesClicked",
        _honeywellinternationalinc:
        {
          productTiles:
          {
            productTilesName: productName,
            productTilesClicked:
            {
              value: 1
            }
          }

        }

      },
      "/gloves-selector"
    );
    window.open(productUrl)
    return styleNumberSelected;


  };
  const sendTextToAnalytics = (len) => {
    const customData = {
      "event": "searchClick",
      searchKeyword: searchTermText,
      searchResultNumber: productList?.length || 0
    };
    addAnalytics(customData);

  }
  const handlerEnter = (e) => {
    if (e.keyCode === 13) {
      sendTextToAnalytics(productList?.length);
      setFlag(true)
    }

  };

  return (
    <>
      <Breadcrumb />
      <div className="gloves-selection">
        <div className='main-title'>
          <div className="textstart"><div className="heading">{t("kclGloves.Gloves")} </div><span>{productList?.length || 0} {t("kclGloves.Product")}</span></div>
          <div className="text-end search-bar">
            <span className='search-icon'><BsSearch onClick={sendTextToAnalytics} /></span>
            <input value={searchTermText} type='text' placeholder={t("kclGloves.Search_Style_Number_Name")} onChange={handleSearch} onKeyDown={handlerEnter} />
          </div>
        </div>
        <div className="row px-0 breakthrough-time">
          <div className="col-md-2 col-12 gloves-filters">
            <FilterFacets flow={FACET_FLOWS.GLOVES_SELECTOR} searchQuery={searchTermText} flag={setflag} onclick={() => setFlag(false)} maxFilters={15} />
          </div>
          <div className="col-md-10 col-12 pl-3">
            <div className="row row-cols-5">
              {
                productList?.length == 0 || productList === undefined ? (
                  <>
                    <div className='no-results-found'>
                      <div className='title'>{sucessMsg && (<>
                        <div className="title">
                          {t("kclGloves.No_Results_Found")}
                        </div>
                        {searchTermText && (
                          <div className="subTitle">
                            '{searchTermText}'
                            <span>{t("kclGloves.Please_Try_Later")}</span>
                          </div>
                        )}
                      </>)}</div>
                    </div>
                  </>
                ) : (
                  productList?.slice(0, displayItems).map((item) => (
                    <>
                      <div className="col product" key={item?.id?.raw} onClick={() => showProductPDF(item?.product_name?.raw, item?.pdf_url?.raw)}>
                        <img src={item?.image_url?.raw || ImgNoGloves}
                          alt={t("filterFacets.Image_Not_Avail")}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = ImgNoGloves;
                          }}
                        />
                        <div className='title'>{item?.product_name?.raw}</div>
                        <p> {t("filterFacets.Style_No")}: {item?.style_no?.raw}</p>
                      </div>
                    </>
                  ))
                )
              }
            </div>
            {displayItems < productList?.length && <div className="button button-outline" onClick={() => loadMore()}>{t("kclGloves.LOAD_MORE")}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default GlovesSelector;